import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import QuizIntro from '../views/QuizIntro.vue'
import QuizQuestion from '../views/QuizQuestion.vue'
import QuizResults from '../views/QuizResults.vue'
import QuizFeedback from '../views/QuizFeedback.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'QuizIntro',
    component: QuizIntro
  },
  {
    path: '/quiz-question/',
    name: 'QuizQuestion',
    component: QuizQuestion,
    props: route => ({selectedAnswer: route.params.selectedAnswer})
  },
  {
    path: '/quiz-feedback/',
    name: 'QuizFeedback',
    component: QuizFeedback,
    props: route => ({selectedAnswer: route.params.selectedAnswer})
  },
  {
    path: '/quiz-results/',
    name: 'QuizResults',
    component: QuizResults
  },
  {
    path :'*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

export default router
